import { APIReferenceType, ArdoqId } from '@ardoq/api-types';
import { isEqual } from '@ardoq/common-helpers';
import {
  WorkspaceAndModelLookup,
  getReferenceTypesWithDefaults,
} from '@ardoq/data-model';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { workspaceAndModel$ } from 'streams/workspaceAndModel$';

export type ReferenceTypesByWorkspaceId = Readonly<
  Record<ArdoqId, readonly APIReferenceType[]>
>;

const buildReferenceTypesByWorkspaceId = ({
  workspacesById,
  modelsById,
}: WorkspaceAndModelLookup): ReferenceTypesByWorkspaceId => {
  const referenceTypesByWorkspaceId: Record<ArdoqId, APIReferenceType[]> = {};
  for (const [workspaceId, workspace] of Object.entries(workspacesById)) {
    const model = modelsById[workspace.componentModel];
    referenceTypesByWorkspaceId[workspaceId] =
      getReferenceTypesWithDefaults(model);
  }
  return referenceTypesByWorkspaceId;
};

export const referenceTypesByWorkspaceId$ = workspaceAndModel$.pipe(
  map(buildReferenceTypesByWorkspaceId),
  distinctUntilChanged(isEqual),
  shareReplay({ bufferSize: 1, refCount: true })
);
